<template>
  <section class="primaryInfo">
    <a
      name="home"
      style="
        position: relative;
        top: -420px;
        display: block;
        height: 0;
        overflow: hidden;
      "
    ></a>
    <section class="information">
      <NavCrumbs :crumbProp="crumbProp" v-show="isPc"></NavCrumbs>
      <section class="innerBox">
        <div class="leftMenu">
          <li
            @click="gotoHandle(leftItem.anchorId)"
            :class="[
              'menu-item',
              isActive === leftItem.anchorId ? 'menu-item--active' : '',
            ]"
            v-for="(leftItem, idx) in leftMenus"
            :key="idx"
          >
            {{ $t(leftItem.title)}}
          </li>
        </div>
        <div class="info">
          <!-- <h1>Careers</h1> -->
          <img
            src="../assets/img/career-banner.jpg"
            alt="career-banner"
            style="display: block; margin: 20px auto; max-width: 100%;"
          />
          <p>
            {{$t("careers_cont_text_1")}}
          </p>
          <p>
            {{$t("careers_cont_text_2")}}
          </p>
          <h3>{{$t("careers_cont_text_keyword_1")}}</h3>
          <h3>{{$t("careers_cont_text_keyword_2")}}</h3>
          <h3>{{$t("careers_cont_text_keyword_3")}}</h3>
          <h3>{{$t("careers_cont_text_keyword_4")}}</h3>
          <h3>{{$t("careers_cont_text_keyword_5")}}</h3>
          <h3>{{$t("careers_cont_text_keyword_6")}}</h3>
          <h3>{{$t("careers_cont_text_keyword_7")}}</h3>

          <p>
            {{$t("careers_cont_text_3")}}
          </p>
          <a style="margin-bottom: 40px;" href="mailto:job@totok.ai"
            >job@totok.ai</a
          >
        </div>
        <!-- <div class="cp">All rights reserved, 2020 © Totok Pte. Ltd.</div> -->
      </section>
    </section>
    <Footer></Footer>
    <FootBanner v-show="!isPc && !isIOS"></FootBanner>
  </section>
</template>

<script>
import NavCrumbs from "@/components/NavCrumbs.vue";
import Footer from "@/components/Footer.vue";
import FootBanner from "@/components/FootBanner.vue";

export default {
  metaInfo() {
    return {
      title: "Careers - ToTok Messenger",
      meta: [
        {
          Description:
            "To check how ToTok collect and process your data, please read our privacy policy carefully",
        },
        { property: "og:title", content: "Careers - ToTok Messenger" },
        { property: "og:url", content: "https://totok.ai/careers" },
        { property: "og:type", content: "website" },
        {
          property: "og:image",
          content: "https://static.totok.ai/pic/preview/free_unblocked_call.png",
        },
        {
          property: "og:description",
          content:
            "Enjoy FREE, FAST and FUN calling with your family and friends.",
        },
        { property: "og:site_name", content: "ToTok" },
      ],
    };
  },
  components: {
    NavCrumbs,
    Footer,
    FootBanner,
  },
  data() {
    return {
      crumbProp: {
        // label: "Careers",
        label: "careers_title",
        type: "simple",
      },
      mainPannel: "",
      showinfo: false,
      isActive: "careers",
      leftMenus: [
        {
          // title: "About Us",
          title: "aboutus_title",
          anchorId: "aboutus",
        },
        {
          // title: "Careers",
          title: "careers_title",
          anchorId: "careers",
        },
      ],
    };
  },
  computed: {
    info() {
      return [];
    },
    isPc() {
      return document.body.offsetWidth > 450;
    },
    isIOS() {
      return navigator.userAgent.toLowerCase().indexOf("iphone") >= 0;
    },
  },
  methods: {
    gotoHandle(palice) {
      let routerName = "";
      switch (palice) {
        case "aboutus":
          this.isActive = "aboutus";
          routerName = "aboutus";
          break;
        case "careers":
          this.isActive = "careers";
          routerName = "careers";
          break;
      }
      this.$router.push({name: routerName, query: this.$route.query});
    },
  },
  mounted() {
    this.mainPannel = document.getElementById("mainbox");
  },
};
</script>
<style scoped lang="stylus">
@media only screen and (max-width: 700px) {
  .innerBox {
    margin-bottom:40px;
  }
    .primaryInfo {

        background: #fff;
        height: 82vh;

        div {
            margin-left 20px
            margin-right 20px
        }

        .leftMenu {
            display none
        }

        .info {
            h1 {
                font-family: "sofiapro-regular","Calibri Light","Helvetica Neue" , Roboto, sans-serif;
                font-size: 28px;
                font-weight: 400;
                color: #222222;
                -webkit-font-smoothing: antialiased;
                padding-bottom: 20px;
                padding-top: 40px;
                margin: 0px;
                line-height: 40px;
            }

            h2 {
                font-family: "sofiapro-regular","Calibri Light","Helvetica Neue" , Roboto, sans-serif;
                font-size: 24px;
                font-weight: 400;
                color: #4377f2;
                -webkit-font-smoothing: antialiased;
                padding-bottom: 18px;
                padding-top: 28px;
                margin: 0px;
            }

            h3 {
                font-family: "sofiapro-regular","Calibri Light","Helvetica Neue" , Roboto, sans-serif;
                font-size: 18px;
                font-weight: 400;
                padding-bottom: 20px;
                margin: 0;
            }

            p {
                font-family: "sofiapro-regular","Calibri Light","Helvetica Neue" , Roboto, sans-serif;
                font-size: 16px;
                font-weight: normal;
                margin-bottom: 12px;
                color: #555555;
                text-rendering: optimizeLegibility;
                line-height: 26px;
            }

            ul {
                list-style: disc;
                font-family: "sofiapro-regular","Calibri Light","Helvetica Neue" , Roboto, sans-serif;
                font-size: 16px;
                font-weight: normal;
                margin-top: 0;
                margin-bottom: 10px;
                margin-left: 24px;
                color: #555555;
                text-rendering: optimizeLegibility;
                line-height: 26px;
            }

            li {
                font-family: "sofiapro-regular","Calibri Light","Helvetica Neue" , Roboto, sans-serif;
                font-size: 16px;
                font-weight: normal;
                margin-top: 0px;
                margin-bottom: 10px;
                color: #555555;
                text-rendering: optimizeLegibility;
                line-height: 26px;
                margin-left: 20px;
            }

            a {
                font-family: "sofiapro-regular","Calibri Light","Helvetica Neue" , Roboto, sans-serif;
                font-size: 16px;
                font-weight: normal;
                margin-top: 0px;
                margin-bottom: 10px;
                color: #4377f2;
                text-rendering: optimizeLegibility;
                line-height: 26px;
            }
        }
    }

    .cp {
        height: 3.5rem;
        font-size: 13px;
        color: #808080;
        line-height: 3.5rem;
        text-align: center;
    }
}

@media only screen and (min-width: 701px) {
    .primaryInfo {
        padding-top: 86px;
        width: 100vw;
        background: #fff;

        .information {
            margin: 0 auto;
            width: 800px;

            .innerBox {
                position relative;
                display: flex;
                flex-direction: column;
                justify-content: space-between;
                align-items: flex-end;
                width:800px;
                min-height: 83vh;
                overflow: auto;

                .leftMenu {
                    position: absolute;
                    left: 0px;
                    top: 39px;
                    display flex;
                    flex-direction column;
                    justify-content center;
                    align-items: flex-start;
                    list-style none;

                    .menu-item {
                        color: #979797;
                        margin-top: 30px;
                        cursor pointer;
                        text-decoration none;
                        font-size: 15px;
                    }

                    .menu-item:nth-child(1) {
                        margin-top: 0px;
                    }

                    .menu-item--active {
                        color: #000;
                        border-bottom: 2px solid #4377f2;
                    }

                }
            }
        }

        .info {
            width: 620px;
            margin: 20px 0;
margin-bottom:60px;
            h1 {
                font-family: "sofiapro-regular","Calibri Light","Helvetica Neue" , Roboto, sans-serif;
                font-size: 28px;
                font-weight: 400;
                color: #222222;
                -webkit-font-smoothing: antialiased;
                padding-bottom: 20px;
                padding-top: 20px;
                margin: 0px;
                line-height: 40px;
            }

            h2 {
                font-family: "sofiapro-regular","Calibri Light","Helvetica Neue" , Roboto, sans-serif;
                font-size: 24px;
                font-weight: 400;
                color: #4377f2;
                -webkit-font-smoothing: antialiased;
                padding-bottom: 18px;
                padding-top: 28px;
                margin: 0px;
            }

            h3 {
                font-family: "sofiapro-regular","Calibri Light","Helvetica Neue" , Roboto, sans-serif;
                font-size: 18px;
                font-weight: 400;
                padding-bottom: 20px;
                margin: 0;
            }

            p {
                font-family: "sofiapro-regular","Calibri Light","Helvetica Neue" , Roboto, sans-serif;
                font-size: 16px;
                font-weight: normal;
                margin-bottom: 12px;
                color: #555555;
                text-rendering: optimizeLegibility;
                line-height: 26px;
            }

            ul {
                list-style: disc;
                font-family: "sofiapro-regular","Calibri Light","Helvetica Neue" , Roboto, sans-serif;
                font-size: 16px;
                font-weight: normal;
                margin-top: 0;
                margin-bottom: 10px;
                margin-left: 24px;
                color: #555555;
                text-rendering: optimizeLegibility;
                line-height: 26px;
            }

            li {
                font-family: "sofiapro-regular","Calibri Light","Helvetica Neue" , Roboto, sans-serif;
                font-size: 16px;
                font-weight: normal;
                margin-top: 0px;
                margin-bottom: 10px;
                color: #555555;
                text-rendering: optimizeLegibility;
                line-height: 26px;
                margin-left: 20px;
            }

            a {
                font-family: "sofiapro-regular","Calibri Light","Helvetica Neue" , Roboto, sans-serif;
                font-size: 16px;
                font-weight: normal;
                margin-top: 0px;
                margin-bottom: 10px;
                color: #4377f2;
                text-rendering: optimizeLegibility;
                line-height: 26px;
            }

        }
    }

    .cp {
        height: 70px;
        font-size: 13px;
        color: #808080;
        line-height: 70px;
        text-align: center;
    }
}
</style>
